import moment from "moment";

import Keys from "../constants/Keys";

export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png"] as const;
export const DOCUMENT_EXTENSIONS = ["pdf"] as const;
export const EMAIL_EXTENSIONS = ["eml", "msg"] as const;

export const ACCEPTED_EXTENSIONS = new Set([
  ...IMAGE_EXTENSIONS,
  ...DOCUMENT_EXTENSIONS,
  ...EMAIL_EXTENSIONS,
]);

export const getTempPath = (binusianId: string, ext: string): string => {
  const tempFilename = encodeURIComponent(`${binusianId}.${ext}`);
  return `Temp/${tempFilename}`;
};

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split(".");
  if (parts.length === 1 || (parts[0] === "" && parts.length === 2)) {
    return ""; // No extension found
  }
  return parts.pop()!.toLowerCase();
};

export const getSharePointUrl = (path: string): string =>
  `${
    Keys.Public_CDN
  }alesa-public-cdn/get-icon-logo-byurl?uri=https://publiccdn.sharepointonline.com/${
    Keys.SharePoint_BaseUrl
  }FileRepository/${encodeURIComponent(path)}&t=${moment().valueOf()}`;

export const getOfficePreviewUrl = (originalUrl: string): string =>
  `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
    originalUrl
  )}`;

export const isValidFileSize = (size: number): boolean => {
  const MAX_FILE_SIZE = 10_000_000; // 10MB
  return size < MAX_FILE_SIZE;
};
